module.exports = __webpack_public_path__ + "img/Qr.2eea043f.png";